import React, { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Minimal wrapper for Sales routes: access check + Outlet.
 * Sales users: dashboard, menu (New Order), orders. Admin: orders, edit-menu.
 */
export default function SalesLayout() {
  const { user, canAccessPage } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const canAccess = user && (canAccessPage('sales') || canAccessPage('sales/dashboard') || canAccessPage('sales/orders') || canAccessPage('sales/orders-history') || canAccessPage('sales/revenue') || canAccessPage('sales/edit-menu'));
  const pageKey = location.pathname.slice(1);
  const isSalesRevenue = pageKey === 'sales/revenue';
  const canAccessCurrentPage =
    !pageKey.startsWith('sales/') ||
    canAccessPage(pageKey) ||
    (isSalesRevenue && user?.role === 'custom_role_sales');

  useEffect(() => {
    if (!user) return;
    if (!canAccess) {
      navigate('/dashboard', { replace: true });
      return;
    }
    if (!canAccessCurrentPage) {
      navigate('/sales/dashboard', { replace: true });
    }
  }, [user, canAccess, canAccessCurrentPage, navigate]);

  if (user && !canAccess) {
    return null;
  }
  if (user && canAccess && !canAccessCurrentPage) {
    return null;
  }

  return <Outlet />;
}
